/**
 * /dashboard/accounting/money/payments/new — Create payment (G_ACC6c).
 *
 * ?bill_id= pre-fills the form from a bill — the bill detail's "Record
 * payment" action links here (wave-2 lite books): the vendor, the
 * allocation to that bill and what is still due.
 *
 * Migration note (Phase 3e — 2026-06-01): port of
 * frontend/src/app/(dashboard)/dashboard/accounting/money/payments/new/page.tsx.
 */

import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { AccountingModuleShell } from "@/components/shared/accounting-module-shell";
import { PaymentForm } from "@/components/accounting/payment-form";

const newPaymentSearchSchema = z.object({
  bill_id: z.coerce.number().int().positive().optional().catch(undefined),
});

export const Route = createFileRoute(
  "/_authgated/app/$tenantSlug/accounting/money/payments/new",
)({
  validateSearch: newPaymentSearchSchema,
  component: NewPaymentRoute,
});

function NewPaymentRoute() {
  const { bill_id: prefillBillId } = Route.useSearch();
  // Top-of-page Back button removed per Audit 4 Quick-Win #4 — the
  // bottom Cancel handles it.
  return (
    <AccountingModuleShell
      title="New Payment"
      description="Record a vendor payment with TDS support."
    >
      {/* Re-key on the bill so a second "Record payment" re-seeds. */}
      <PaymentForm key={prefillBillId ?? "blank"} prefillBillId={prefillBillId} />
    </AccountingModuleShell>
  );
}
